document.addEventListener('submit', function (event) {
  var form = event.target;
  if (!form || form.getAttribute('id') !== 'AddToCartForm') return;

  var productId = form.getAttribute('data-loop-product-id');
  var widget = window.LOOP_WIDGET && productId && window.LOOP_WIDGET[productId];
  if (!widget) return;

  if (widget.loopWidgetProductForms) {
    widget.loopWidgetProductForms = [form];
  }

  var planId = widget.selectedSellingPlanId;
  var input = form.querySelector('input[name="selling_plan"]');

  if (!planId) {
    if (input) input.remove();
    return;
  }

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'selling_plan';
    form.appendChild(input);
  }

  input.disabled = false;
  input.value = planId;
}, true);
